import React from "react";
import clsx from "clsx";
import { useStaticQuery, Link } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  nav: {
    position: "relative",
    "@media(max-width: 768px)": {
      display: "none"
    }
  },
  navHeader: {
    textTransform: "uppercase",
    fontSize: "0.8125rem!important",
    textAlign: "right",
    color: theme.palette.text.secondary
  },
  inner: {
    position: "sticky",
    top: "16px",
    padding: "0 16px",
    "& a": {
      display: "block",
      textDecoration: "none",
      color: theme.palette.text.primary,
      lineHeight: 1.6,
      textAlign: "right",
      fontWeight: 500,
      transition: theme.transitions.create(["color"], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shortest
      }),
      "&:hover": { color: theme.app.linkHoverColor }
    }
  },
  link: {},
  active: {
    color: `${theme.palette.secondary.main}!important`,
    pointerEvents: "none",
    cursor: "auto"
  }
}));

const query = graphql`
  query {
    allContentfulReference(sort: { fields: index }) {
      edges {
        node {
          id
          title
          slug
        }
      }
    }
  }
`;

const Nav = ({ location }) => {
  const classes = useStyles();
  const {
    allContentfulReference: { edges }
  } = useStaticQuery(query);

  return (
    <div className={classes.nav}>
      <div className={classes.inner}>
        <Typography className={classes.navHeader}>Navigering</Typography>
        {edges.map(p => {
          const path = location.pathname.split("/");
          const isActive = path[path.length - 2] === p.node.slug;
          return (
            <Link
              className={clsx(classes.link, isActive && classes.active)}
              to={`/reference/${p.node.slug}/`}
              key={p.node.id}
            >
              <span>{p.node.title}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Nav;
